import React from 'react';

// A captioned group box (.stui-frame), like a Frame in VB forms. Omit `caption` for a plain frame.
const StuiFrame = ({ caption, className = '', children }) => (
  <fieldset className={`stui-frame${className ? ` ${className}` : ''}`}>
    {caption && <legend>{caption}</legend>}
    {children}
  </fieldset>
);

export default StuiFrame;
